/**
 * Configurazione di default per il FilterHandler
 *
 * @description
 * Contiene le impostazioni predefinite per il comportamento del sistema di filtri.
 * Queste configurazioni controllano aspetti come l'aggiornamento automatico della route
 * e i tempi di debouncing per le ricerche.
 */

/**
 * Interfaccia per la configurazione del FilterHandler
 */
export interface FilterConfiguration {
	/** Se true, aggiorna automaticamente la route quando i filtri cambiano */
	replaceRouteOnQueryUpdate: boolean;
	/** Tempo di debouncing in millisecondi per evitare ricerche troppo frequenti */
	debounceTimeoutValue: number;
}

/**
 * Configurazione di default del FilterHandler
 *
 * @example
 * // Utilizzare la configurazione di default
 * import { defaultConfiguration } from '@/mixins/filterHandler/lib';
 *
 * const config = { ...defaultConfiguration, debounceTimeoutValue: 500 };
 */
export const defaultConfiguration: FilterConfiguration = {
	replaceRouteOnQueryUpdate: true,
	debounceTimeoutValue: 300,
} as const;
